import { setRange } from './helpers';

export const setWorkplaceCount = setRange('workplace_count');
